import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SuperAdminTable } from '../../../SuperAdmin/components/baseComponents/Table';
import { getPreBuiltAdminTemplates } from '../../store/actions/settings';
import EditPreBuiltTemplateAdminPage from './EditPreBuiltTemplateAdmin.page';
import { Dropdown, Menu } from 'antd';
import { ActionMenuIcon, EditAppointmentIcon } from 'src/icons';

const PreBuiltTemplateAdminPage = () => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [editTemplateMappingModalOpen, setEditTemplateMappingModalOpen] =
    useState(false);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [selectedPhase, setSelectedPhase] = useState('');

  const { templateAdminList, isTemplateAdminListLoading } = useSelector(
    (state) => state?.settingsState
  );

  useEffect(() => {
    dispatch(getPreBuiltAdminTemplates());
  }, []);

  useEffect(() => {
    if (templateAdminList.length > 0) {
      setTableData(templateAdminList);
    }
  }, [templateAdminList]);

  useEffect(() => {
    setTableLoader(isTemplateAdminListLoading);
  }, [isTemplateAdminListLoading]);

  const menu_options = (record) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editTemplates') {
            setSelectedPhase(record?.encounter_phase);
            setSelectedTemplates(record?.templates);
            setEditTemplateMappingModalOpen(true);
          }
        }}
      >
        <Menu.Item key="editTemplates">
          <div className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit mapping</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: 'Encounter phase',
      render: (text, record) => {
        return (
          <div>
            {record?.encounter_phase?.charAt(0).toUpperCase() +
              record?.encounter_phase?.slice(1)}
          </div>
        );
      },
    },
    {
      title: 'Pre-built templates',
      dataIndex: 'templates',
      width: '75%',
      render: (text, record) => {
        return (
          <div className="flex flex-wrap gap-2">
            {record?.templates?.map((template, index) => {
              return (
                <div
                  key={index}
                  className="flex items-center px-3 py-1 gap-1 mt-2 w-fit rounded-3xl"
                  style={{ border: `1px solid #00D090` }}
                >
                  {template.name}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <Dropdown className="" overlay={menu_options(record)}>
            <a className="" onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <div className="super-admin-table mt-10">
        <div className="mt-5 ant-table rounded-xl shadow-xl">
          <SuperAdminTable
            className={`appointment-page-table`}
            columns={columns}
            data={tableData}
            loading={tableLoader}
          />
        </div>
      </div>
      <EditPreBuiltTemplateAdminPage
        isOpen={editTemplateMappingModalOpen}
        setIsOpen={setEditTemplateMappingModalOpen}
        selectedTemplates={selectedTemplates}
        selectedPhase={selectedPhase}
      />
    </>
  );
};

export default PreBuiltTemplateAdminPage;
